(function () {
  if (window.__ppTiltInit) return;
  window.__ppTiltInit = true;

  var SELECTOR = '.prime-picks-testimonials-premium .m-testimonial__wrapper';
  var MAX_TILT = 8; // degrees
  var isCoarsePointer =
    window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  function onMove(card, clientX, clientY) {
    var rect = card.getBoundingClientRect();
    var px = (clientX - rect.left) / rect.width;
    var py = (clientY - rect.top) / rect.height;
    px = Math.min(1, Math.max(0, px));
    py = Math.min(1, Math.max(0, py));

    var rotateY = (px - 0.5) * MAX_TILT * 2;
    var rotateX = (0.5 - py) * MAX_TILT * 2;

    card.style.setProperty('--tilt-x', rotateX.toFixed(2) + 'deg');
    card.style.setProperty('--tilt-y', rotateY.toFixed(2) + 'deg');
    card.style.setProperty('--glare-x', (px * 100).toFixed(1) + '%');
    card.style.setProperty('--glare-y', (py * 100).toFixed(1) + '%');
    card.style.setProperty('--lift', '10px');
    card.style.setProperty('--scale', '1.015');
    card.classList.add('is-tilting');
  }

  function onLeave(card) {
    card.style.setProperty('--tilt-x', '0deg');
    card.style.setProperty('--tilt-y', '0deg');
    card.style.setProperty('--lift', '0px');
    card.style.setProperty('--scale', '1');
    card.style.setProperty('--glare-x', '50%');
    card.style.setProperty('--glare-y', '50%');
    card.classList.remove('is-tilting');
  }

  function initCard(card) {
    if (card.__ppTiltInit || isCoarsePointer) return;
    card.__ppTiltInit = true;

    card.addEventListener('mousemove', function (e) {
      window.requestAnimationFrame(function () {
        onMove(card, e.clientX, e.clientY);
      });
    });
    card.addEventListener('mouseleave', function () {
      onLeave(card);
    });
  }

  function setup(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
    });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target);
  });
})();
